function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { Modal, Drawer, Divider, Stack, Button } from "@mui/material";
import AiOutlineDown from "@meronex/icons/ai/AiOutlineDown";
import BiArrowBack from "@meronex/icons/bi/BiArrowBack";
import Scrollbar from "./Scrollbar";
import PriceRange from "./PriceRange";
import ApartmentToggle from "./ApartmentToggle";
import CityList from "./CityList";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ProjectFilter = function ProjectFilter(_ref) {
  var _config$projects, _config$projects2, _config$projects3, _config$projects4, _config$projects5;
  var isOpenFilter = _ref.isOpenFilter,
    onResetFilter = _ref.onResetFilter,
    applyFilter = _ref.applyFilter,
    onCloseFilter = _ref.onCloseFilter,
    winnreNoAuth = _ref.winnreNoAuth,
    config = _ref.config;
  // Presentation and selected values
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    pCities = _useState2[0],
    setPCities = _useState2[1];
  var _useState3 = useState([0, 100]),
    _useState4 = _slicedToArray(_useState3, 2),
    pRange = _useState4[0],
    setPRange = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    pApartment = _useState6[0],
    setPApartment = _useState6[1];

  // Actual filter payloads
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    cities = _useState8[0],
    setCities = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    range = _useState0[0],
    setRange = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    apartment = _useState10[0],
    setApartment = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    apartmentTypesList = _useState12[0],
    setApartmentTypesList = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    projectCityList = _useState14[0],
    setProjectCityList = _useState14[1];
  var _useState15 = useState(true),
    _useState16 = _slicedToArray(_useState15, 2),
    cityShow = _useState16[0],
    setCityShow = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    rangeShow = _useState18[0],
    setRangeShow = _useState18[1];
  var _useState19 = useState(true),
    _useState20 = _slicedToArray(_useState19, 2),
    apartmentShow = _useState20[0],
    setApartmentShow = _useState20[1];
  useEffect(function () {
    if (!winnreNoAuth) return;
    winnreNoAuth.get("/winnre/user/project/apartment-types").then(function (data) {
      return setApartmentTypesList(data || []);
    });
    winnreNoAuth.get("/winnre/no-auth/enum/enquiry-project-cities").then(function (data) {
      return setProjectCityList(data || []);
    });
  }, [winnreNoAuth]);
  var cityUpdate = function cityUpdate(updated) {
    // updated: array of { name, checked }
    var selected = updated.filter(function (c) {
      return c.checked;
    }).map(function (c) {
      return c.name;
    });
    setPCities(selected);
    setCities(selected);
  };
  var priceUpdate = function priceUpdate(price) {
    // price: [minL, maxL]
    setPRange(price);
    var minPrice = 1000000 * price[0];
    var maxPrice = 1000000 * price[1];
    setRange([minPrice, maxPrice]);
  };
  var apartmentUpdate = function apartmentUpdate(selected) {
    setPApartment(selected);
    setApartment(selected);
  };
  var applyFilters = function applyFilters() {
    if (typeof window !== "undefined") {
      try {
        var _window;
        (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("FilterApplied", {
          Layout: apartment.join(),
          Locations: cities.join(),
          Budget: "".concat(range.length === 0 ? 0 : range[0], " - ").concat(range.length === 0 ? 99999999999 : range[1])
        });
      } catch (e) {}
    }
    applyFilter(cities, range, apartment);
  };
  var clearFilter = function clearFilter() {
    setPCities([]);
    setPRange([0, 100]);
    setPApartment([]);
    onResetFilter === null || onResetFilter === void 0 || onResetFilter();
  };
  if (!isOpenFilter) return null;
  return /*#__PURE__*/_jsx(Modal, {
    open: isOpenFilter,
    onClose: onCloseFilter,
    children: /*#__PURE__*/_jsx(Drawer, {
      variant: "persistent",
      anchor: "right",
      open: isOpenFilter,
      onClose: onCloseFilter,
      elevation: 8,
      PaperProps: {
        sx: {
          width: {
            xs: "100%",
            md: 400
          },
          border: "none",
          overflow: "hidden"
        }
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col h-[100%] ".concat(config !== null && config !== void 0 && config.darkMode ? "bg-black text-base-content" : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white")),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "",
          children: [/*#__PURE__*/_jsxs(Stack, {
            direction: "row",
            alignItems: "center",
            justifyContent: "space-between",
            sx: {
              mx: 3,
              py: 2
            },
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex",
              children: [/*#__PURE__*/_jsx(BiArrowBack, {
                onClick: onCloseFilter,
                className: "cursor-pointer my-auto mr-2 h-6 w-6"
              }), /*#__PURE__*/_jsx("p", {
                className: "text-xl font-semibold ".concat(config === null || config === void 0 || (_config$projects = config.projects) === null || _config$projects === void 0 || (_config$projects = _config$projects.moduleConfig) === null || _config$projects === void 0 ? void 0 : _config$projects.fontTitle),
                children: "Filter"
              })]
            }), /*#__PURE__*/_jsx("p", {
              onClick: clearFilter,
              className: "text-lg cursor-pointer text-primary ".concat(config === null || config === void 0 || (_config$projects2 = config.projects) === null || _config$projects2 === void 0 || (_config$projects2 = _config$projects2.moduleConfig) === null || _config$projects2 === void 0 ? void 0 : _config$projects2.fontBody),
              children: "Clear All"
            })]
          }), /*#__PURE__*/_jsx(Divider, {
            sx: {
              mx: 3
            }
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "flex-1 overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-300",
          children: /*#__PURE__*/_jsx(Scrollbar, {
            children: /*#__PURE__*/_jsxs(Stack, {
              sx: {
                mx: 4,
                mt: 1
              },
              children: [projectCityList.length > 1 && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs("div", {
                  onClick: function onClick() {
                    return setCityShow(!cityShow);
                  },
                  className: "cursor-pointer flex justify-between mb-2",
                  children: [/*#__PURE__*/_jsx("p", {
                    className: "text-lg font-bold ".concat(config === null || config === void 0 || (_config$projects3 = config.projects) === null || _config$projects3 === void 0 || (_config$projects3 = _config$projects3.moduleConfig) === null || _config$projects3 === void 0 ? void 0 : _config$projects3.fontTitle),
                    children: "Location"
                  }), /*#__PURE__*/_jsx(AiOutlineDown, {
                    className: "my-auto"
                  })]
                }), cityShow && /*#__PURE__*/_jsx(CityList, {
                  cities: pCities,
                  cityUpdate: cityUpdate,
                  projectCityList: projectCityList,
                  config: config
                }), /*#__PURE__*/_jsx(Divider, {
                  sx: {
                    margin: "12px 0"
                  }
                })]
              }), /*#__PURE__*/_jsxs("div", {
                onClick: function onClick() {
                  return setRangeShow(!rangeShow);
                },
                className: "cursor-pointer flex justify-between mb-2",
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-lg font-bold ".concat(config === null || config === void 0 || (_config$projects4 = config.projects) === null || _config$projects4 === void 0 || (_config$projects4 = _config$projects4.moduleConfig) === null || _config$projects4 === void 0 ? void 0 : _config$projects4.fontTitle),
                  children: "Budget"
                }), /*#__PURE__*/_jsx(AiOutlineDown, {
                  className: "my-auto"
                })]
              }), rangeShow && /*#__PURE__*/_jsx(PriceRange, {
                range: pRange,
                priceUpdate: priceUpdate,
                config: config,
                winnreNoAuth: winnreNoAuth
              }), /*#__PURE__*/_jsx(Divider, {
                sx: {
                  margin: "12px 0"
                }
              }), /*#__PURE__*/_jsxs("div", {
                onClick: function onClick() {
                  return setApartmentShow(!apartmentShow);
                },
                className: "cursor-pointer flex justify-between mb-2 ".concat(config === null || config === void 0 || (_config$projects5 = config.projects) === null || _config$projects5 === void 0 || (_config$projects5 = _config$projects5.moduleConfig) === null || _config$projects5 === void 0 ? void 0 : _config$projects5.fontTitle),
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-lg font-bold",
                  children: "No. of Bedrooms"
                }), /*#__PURE__*/_jsx(AiOutlineDown, {
                  className: "my-auto"
                })]
              }), apartmentShow && /*#__PURE__*/_jsx(ApartmentToggle, {
                apartments: pApartment,
                apartmentUpdate: apartmentUpdate,
                apartmentTypes: apartmentTypesList,
                config: config
              })]
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "w-full py-4 px-8",
          children: /*#__PURE__*/_jsxs(Stack, {
            direction: "row",
            justifyContent: "space-between",
            children: [/*#__PURE__*/_jsx(Button, {
              type: "submit",
              sx: {
                paddingX: 4,
                paddingY: 1,
                background: "#BFBFBF",
                "&:hover": {
                  background: "#AAAAAA"
                },
                fontWeight: "bold"
              },
              variant: "contained",
              onClick: onCloseFilter,
              children: "Cancel"
            }), /*#__PURE__*/_jsx(Button, {
              type: "submit",
              variant: "contained",
              sx: {
                paddingX: 4,
                paddingY: 1,
                background: config === null || config === void 0 ? void 0 : config.primaryColor,
                "&:hover": {
                  background: config === null || config === void 0 ? void 0 : config.primaryColor,
                  opacity: "90%"
                },
                fontWeight: "bold"
              },
              onClick: applyFilters,
              children: "Apply Filters"
            })]
          })
        })]
      })
    })
  });
};
export default ProjectFilter;